// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warpp[data-v-04b622bf] .el-collapse-item__header {\n  color: #00A551;\n  font-size: 16px;\n}\n.warpp[data-v-04b622bf] .el-descriptions-item__label {\n  font-size: 13px;\n  color: #909399;\n}\n.warpp[data-v-04b622bf] .el-descriptions-item__cell {\n  /*height: 35px !important;*/\n  padding-bottom: 2px !important;\n}\n", ""]);
// Exports
module.exports = exports;
